import FloatLabelInput from '@src/main/shared/ui/components/input/FloatLabelInput';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './PositionForm.module.scss';

interface PositionFormProps {
  values: {
    position: string;
    description: string;
  };
  handleChange: (field: keyof PositionFormProps['values'], value: string) => void;
  errors?: Record<string, string>;
}

const PositionForm: FC<PositionFormProps> = ({ values, handleChange, errors }) => {
  const { t } = useTranslation();

  return (
    <form>
      <div className={styles.grid}>
        <FloatLabelInput
          label={t('parameters.fleetsAndPositions.positions.position')}
          value={values.position}
          onChange={(val) => handleChange('position', val)}
          error={errors?.position}
          className={`${styles.field} col-12`}
          inputClassName={styles.inputfield}
        />

        <FloatLabelInput
          label={t('parameters.fleetsAndPositions.positions.description')}
          value={values.description}
          onChange={(val) => handleChange('description', val)}
          error={errors?.description}
          className={`${styles.field} col-12`}
          inputClassName={styles.inputfield}
        />
      </div>
    </form>
  );
};

export default PositionForm;
